import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [{ path: '', component: () => import('pages/IndexPage.vue') }]
  },

  {
    path: '/:tenantId/sign/:signKey',
    component: () => import('src/layouts/SignableDocumentLayout.vue'),
    children: [{ path: '', component: () => import('src/pages/SignableDocumentPage.vue') }]
  },

  // Always leave this as last one
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue')
  }
]

export default routes
